/* Presale product page: swipe gallery + thumbnails, sticky mobile CTA,
   scroll-to-form, scroll reveals. No framework. */

(function () {
  "use strict";
  document.documentElement.classList.add("js");

  // ---------------------------------------------------------------- gallery
  var track = document.querySelector("[data-gallery-track]");
  var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-thumb]"));
  if (track && thumbs.length) {
    var mark = function (i) {
      thumbs.forEach(function (t, k) { t.setAttribute("aria-current", k === i ? "true" : "false"); });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
        mark(i);
      });
    });
    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
    track.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      track.scrollBy({ left: (e.key === "ArrowRight" ? 1 : -1) * track.clientWidth, behavior: "smooth" });
    });
  }

  // ------------------------------------------------------- jump to the form
  var form = document.getElementById("presale");
  var email = document.getElementById("pdp-email");
  document.querySelectorAll("[data-pdp-jump]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: "smooth", block: "center" });
      if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 450);
    });
  });

  // After a signup Shopify reloads the page with ?customer_posted=true.
  if (form && /customer_posted=true/.test(location.search)) {
    form.scrollIntoView({ block: "center" });
  }

  // ------------------------------------------------- sticky CTA (mobile only)
  var sticky = document.querySelector("[data-sticky]");
  if (sticky && form && "IntersectionObserver" in window) {
    sticky.hidden = false;
    var past = false, formVisible = false, footVisible = false;
    var update = function () { sticky.classList.toggle("is-on", past && !formVisible && !footVisible); };
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        formVisible = en.isIntersecting;
        past = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      update();
    }).observe(form);
    var foot = document.querySelector(".join");
    if (foot) new IntersectionObserver(function (es) { footVisible = es[0].isIntersecting; update(); }).observe(foot);
  }

  // ------------------------------------------------- pre-order buy box
  var poForm = document.querySelector("[data-preorder]");
  if (poForm) {
    var qty = poForm.querySelector("#pdp-qty");
    poForm.querySelectorAll("[data-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.step, 10)));
        qty.value = v;
      });
    });
    var vJson = poForm.querySelector("[data-variants]");
    var variants = vJson ? JSON.parse(vJson.textContent) : null;
    var buy = poForm.querySelector("[data-buy]");
    if (variants) {
      poForm.addEventListener("change", function (e) {
        if (!e.target.matches("[data-opt]")) return;
        var picked = [];
        poForm.querySelectorAll("[data-opt]:checked").forEach(function (r) { picked[+r.dataset.opt] = r.value; });
        poForm.querySelectorAll("[data-opt-label]").forEach(function (l) { l.textContent = picked[+l.dataset.optLabel] || ""; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === picked[i]; }); });
        if (!v) { buy.disabled = true; buy.textContent = buy.dataset.soldout; return; }
        poForm.querySelector("[data-variant-id]").value = v.id;
        document.querySelectorAll("[data-price]").forEach(function (n) { n.textContent = v.priceText; });
        var cmp = document.querySelector("[data-compare]");
        if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = v.compareText; }
        var ok = v.available && v.price > 0;
        buy.disabled = !ok;
        buy.textContent = ok ? buy.dataset.label : buy.dataset.soldout;
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u); }
      });
    }
    poForm.addEventListener("submit", function () { if (buy && !buy.disabled) { buy.setAttribute("aria-busy", "true"); buy.textContent = "Adding…"; } });
  }

})();
